import PropTypes from 'prop-types';
import React from 'react';

const Conditional = ({ condition, children }) => {
    if (
        condition === false ||
        condition === null ||
        typeof condition === 'undefined' ||
        (typeof condition.length === 'number' && condition.length === 0)
    ) {
        return null;
    }

    if (React.isValidElement(children)) {
        return children;
    }

    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>;
};

Conditional.propTypes = {
    condition: PropTypes.oneOfType([PropTypes.bool, PropTypes.object, PropTypes.string, PropTypes.array]),
};

export default Conditional;
